import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Job Module Service Stores
 * Services for job/project management in ReadyMix operations
 */
export const jobStores: ServiceStoreConfig[] = [
  {
    name: "job",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.jobStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalJobs = entities.length;
          const activeJobs = entities.filter(
            (job: Record<string, unknown>) =>
              job.status === "active" || job.status === "in_progress" || !job.archived
          ).length;
          const completedJobs = entities.filter(
            (job: Record<string, unknown>) =>
              job.status === "completed" || job.status === "finished"
          ).length;
          const highPriorityJobs = entities.filter(
            (job: Record<string, unknown>) =>
              job.priority === "high" || job.priority === "critical"
          ).length;

          return [
            {
              title: "Total Jobs",
              value: () => totalJobs.toString(),
              valueColor: "primary.main",
              variant: "with-icon" as const,
            },
            {
              title: "Active",
              value: () => activeJobs.toString(),
              valueColor: "success.main",
            },
            {
              title: "Completed",
              value: () => completedJobs.toString(),
              valueColor: "info.main",
            },
            {
              title: "High Priority",
              value: () => highPriorityJobs.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["jobNumber", "createdAt"],
          sortDirection: { jobNumber: "DESC", createdAt: "DESC" },
        },
        actions: {
          onRowClick: (row) => {
            console.log("View job:", row.jobId);
          },
          onRowDoubleClick: (row, rootStore) => {
            rootStore.routerStore?.openDialog({
              dialogName: "jobDetail",
              dialogContext: `${row.jobId}`,
            });
          },
        },
      },
    },
  },
];